import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ContentTestsService } from '@inference.engine/api-client/web';

import { CONTENT_TEST_QUERY_KEYS } from '@/entities/content-test';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { inferenceHttp } from '@/lib/api/http-client';

export const useRunContentTest = (testId: string) => {
  const queryClient = useQueryClient();
  const workspaceId = useCurrentWorkspaceId();

  return useMutation({
    mutationFn: () =>
      ContentTestsService.run({
        client: inferenceHttp,
        path: { id: testId },
        throwOnError: true,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: CONTENT_TEST_QUERY_KEYS.detail(testId),
      });
      // Starting a run moves the test from draft to running, which the Overview
      // row renders too. The list key is workspace-scoped and does not nest
      // under the detail key, so it needs its own invalidation — without it the
      // list keeps serving a cached "draft" for the full staleTime.
      if (workspaceId) {
        void queryClient.invalidateQueries({
          queryKey: CONTENT_TEST_QUERY_KEYS.list(workspaceId),
        });
      }
    },
  });
};
